// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ARTICLE_COMPLAINT_TITLE = "Nahlasujem nevhodn\u00fd \u010dl\u00e1nok";
export const ARTICLE_DELETED_BY_ADMIN = "\u010cl\u00e1nok zmazan\u00fd adminom";
export const ARTICLE_DELETED_BY_AUTHOR = "\u010cl\u00e1nok zmazan\u00fd autorom";
export const ARTICLE_DELETED_BY_MODERATOR = "\u010cl\u00e1nok zmazan\u00fd moder\u00e1torkou";
export const BACK_TO_BLOGS = "Sp\u00e4\u0165 na pr\u00edspevky";
export const counter_RATINGS = ["%(counter)s hodnotenie", "%(counter)s hodnotenia", "%(counter)s hodnoten\u00ed"];
export const DIFFICULTY_EASY = "Jednoduch\u00e1";
export const DIFFICULTY_HARD = "N\u00e1ro\u010dn\u00e1";
export const DIFFICULTY_MEDIUM = "Stredne n\u00e1ro\u010dn\u00e1";
export const number_MINUTES = ["%(number)s min\u00fata", "%(number)s min\u00faty", "%(number)s min\u00fat"];
export const PB_RECOMMENDED_ARTICLES = "Odpor\u00fa\u010dame";
export const POST_REMOVE_COMPLAINTS = "Zru\u0161 nahl\u00e1senie pr\u00edspevku";
export const RECIPE_DIFFICULTY_LEVEL_TEXT = "N\u00e1ro\u010dnos\u0165";
export const RECIPE_NUTRITION_CALORIES = "Kal\u00f3rie (kcal)";
export const RECIPE_NUTRITION_CARBS = "Sacharidy (g)";
export const RECIPE_NUTRITION_ENERGY = "Energia (kJ)";
export const RECIPE_NUTRITION_FAT = "Tuky (g)";
export const RECIPE_NUTRITION_FIBER = "Vl\u00e1knina (g)";
export const RECIPE_NUTRITION_PROTEIN = "Bielkoviny (g)";
export const RECIPE_NUTRITION_VALUES_TITLE = "Nutri\u010dn\u00e9 hodnoty (na porciu)";
export const RECIPE_PREPARATION_AND_COOKING_TIME = "Celkov\u00fd \u010das pr\u00edpravy a varenia/pe\u010denia";
export const RECIPE_SERVINGS_COUNT = "Po\u010det porci\u00ed";
export const RECIPE_SERVINGS_COUNT_number = ["%(number)s porcia", "%(number)s porcie", "%(number)s porci\u00ed"];
export const USER_LIKE = "Pridaj k ob\u013e\u00faben\u00fdm";
export const USER_UNLIKE = "Odober z ob\u013e\u00faben\u00fdch";
